import { render, staticRenderFns } from "./FormRenderer.vue?vue&type=template&id=f87ce21a&scoped=true"
import script from "./FormRenderer.vue?vue&type=script&lang=js"
export * from "./FormRenderer.vue?vue&type=script&lang=js"
import style0 from "./FormRenderer.vue?vue&type=style&index=0&id=f87ce21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87ce21a",
  null
  
)

export default component.exports